var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-emergency-plan'),_c('form-client-emergency',{attrs:{"disabled":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }